import React, { useEffect, useState } from "react";
import {
  Typography,
  Stack,
  Box,
  Button,
  InputAdornment,
  TextField,
  Select,
  FormControl,
  MenuItem,
} from "@mui/material";
import ReactApexChart from "react-apexcharts";
import "./attendancepercentage.scss";
import { useQuery } from "@apollo/client";

import { AuthContext } from "../../../Context/AuthContext";
import { translateLauguage } from "../../../Function/Translate";

import { GET_ATTENDANCE_RATE_BY_LEVEL } from "../../../Schema/Dashboard";

import LoadingPage from "../../Include/LoadingPage";

export default function AttendancePercentageByLevel({ academicYearId, schoolId, schoolName}) {
  // Change Language
  const { language } = React.useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [totalData, setTotalData] = useState([]);

  // new query
  const { loading, refetch: refetchData, data } = useQuery(GET_ATTENDANCE_RATE_BY_LEVEL, {
    variables: {
      academicYearId: academicYearId ?? null,
      schoolId: schoolId ?? null
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  useEffect(() => {
    if (data?.getAttendanceRateChartShowByLevel) {
      setTotalData(data.getAttendanceRateChartShowByLevel);
    }
  }, [data])


  const labelData = totalData?.map((e) => {
    return t("grade") + " " + e?.labelNameEng;
  });

  const percentage = totalData?.map((e) => e?.percentage)

  useEffect(() => {
    refetchData();
  }, [academicYearId, schoolId]);


  const state = {
    options: {
      chart: {
        type: "bar",
        height: 350,
        fontFamily: "Khmer OS Siemreap",
        stacked: false,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "50%",
          endingShape: "rounded",
          dataLabels: {
            position: "top", // top, center, bottom
          },
        },
      },
      dataLabels: {
        enabled: true,
        offsetY: -25,
        style: {
          fontSize: "12px",
          colors: ["#304758"],
        },
        formatter: function (val, opts) {
          if (val > 0) {
            return val + " %";
          } else {
            return "0 %";
          }
        },
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: labelData,
        // categories: ["A", "B", "C", "D", "E"],
      },
      yaxis: {
        // max: maxSeriesData + 5,
        labels: {
          style: {
            fontFamily: "Siemreap",
          },
        },
      },
      tooltip: {
        y: {
          formatter: function (val) {
            if (val > 0) {
              return val + " %";
            } else {
              return 0 + " %";
            }
          },
        },
      },
      fill: {
        opacity: 1,
      },
    },
    series: [
      {
        name: t("percentage"),
        data: percentage,
        // data: [10, 15, 20, 25, 30],
        color: "#0071F1",
      },

    ],
  };

  return (
    <Box className="total-enrollment-by-chart-percentage">
      <Stack direction="row" alignItems="center" justifyContent="center">
        <Typography
          className={language === "en" ? "chart-title" : "chart-title-kh"}
        >
          {t("statistic_attendance_percentage_at_school")} {schoolName ? schoolName : t("of_all_school")}
        </Typography>
      </Stack>

      {
        loading ? <LoadingPage /> :
          <div id="chart">
            <ReactApexChart
              options={state.options}
              series={state.series}
              type="bar"
              height={350}
            />
          </div>
      }

    </Box>
  );
}
